import React from 'react';
import ToolCard, { ToolCardPlaceholder } from '@/components/Tools/ToolCard';

function ToolListItem(props) {
  return <ToolCard {...props} compact />;
}

export function ToolListItemPlaceholder() {
  return <ToolCardPlaceholder compact />;
}

export default React.memo(ToolListItem);
